<template>
	<div class="container">
		<section class="content" :class="{ 'shadow-box': $mq.isDesktop() }">
			<template v-if="!complited">

			<greeting-component />
			<div class="label">Come possiamo aiutarti?</div>
			<div class="label">Vi scrivo in merito a:</div>

			<div class="faq-section" v-for="(value, key) in ($options.faq)" :key="key">
				<div
					class="faq-category flex faq-trigger"
					@click="toggle(key)"
					:class="{ 'rotated': openedCategoryId !== key, 'active': openedCategoryId === key }"
					:id="key"
				>
					<div class="icon"><span v-if="key === '1'"><i class="fas fa-lemon"></i></span>
					<span v-if="key === '2'"><i class="fa fa-truck"></i></span>
					<span v-if="key === '3'"><i class="fa fa-newspaper-o fa-rotate-180" aria-hidden="true"></i></span>
					<span v-if="key === '4'"><i class="fas fa-heart"></i></span></div>

					{{ value.nameMobile && !$mq.isDesktop() ? value.nameMobile : value.name }}
				</div>

				<div v-if="openedCategoryId === key">
					<freshdesk-form
						:user='user'						
						:subjects="subjects"
						@success="success"
						:sectionName='sectionName'
					/>
				</div>
			</div>
			</template>
			<template v-if="complited">
				<h2>Grazie per averci scritto!</h2>
				<div class="label">
					Uno dei nostri operatori ti risponderà nel minor tempo possibile.
					<br><br>
					Hai domande su come gestire l'abbonamento, le spedizioni e i pagamenti?
					<br>
					Consulta la sezione <router-link :to="{ name: 'faq' }" class="link-detail">"Le domande frequenti"</router-link> del nostro sito per quesiti generici. La risposa alla tua domanda potrebbe essere già lì!
					<br><br>
					Grazie per il feedback!
					<br><br>
					Buon divertimento in cucina,
					<br>
					il team Quomi.
				</div>
			</template>
		</section>
		<section class="go-to-faq pa-10">	
			<h1 class="text-bold">Hai qualche dubbio?</h1>
			<p>Visita la pagina delle domande frequenti.</p>
			<CTA
				isWithLoader
				:content="`Vai alle domande frequenti`"
				@click="goToFaq()"
			/>
		</section>
	</div>
</template>

<script>
import TriangleImage from './TriangleImage'
import FreshdeskForm from './FreshdeskForm'
import HomeGreeting from './Home/HomeGreeting'
import { scrollToElementId } from '../assets/js/main'

export default {
	faq: {
		1: {
			nameMobile: 'Gli ingredienti e/o i prodotti extra',
			name: 'Gli ingredienti e/o i prodotti extra ricevuti',
			content: [
				{
					id: 11,
					name: 'Prodotti rotti e/o danneggiati',
					type: 'Prodotti rotti e/o danneggiati',
					attachReq: true
				},
				{
					id: 12,
					name: 'Prodotti oltre la data di scadenza',
					type: 'Prodotti oltre la data di scadenza',
					attachReq: true
				},
				{
					id: 13,
					name: 'Prodotti errati',
					type: 'Prodotti errati',
					attachReq: true
				},
				{
					id: 14,
					name: 'Prodotti mancanti e in quantità errata',
					type: 'Prodotti mancanti e in quantità errata'
				},
				{
					id: 15,
					name: 'Istruzioni su ricette assenti e/o errate',
					type: 'Istruzioni su ricette assenti e/o errate',
					attachReq: true
				}
			]
		},

		2: {
			name: 'Domande sulla spedizione',
			nameMobile: 'Domande sulla spedizione',
			content: [
				{
					id: 21,
					name: 'Ritardo / mancata consegna',
					type: 'Ritardo / mancata consegna'
				},
				{
					id: 22,
					name: 'Modifica indirizzo di consegna / problemi di reperibilità',
					type: 'Modifica indirizzo di consegna / problemi di reperibilità'
				}
			]
		},
		3: {
			name: 'Supporto sulla gestione dell’ordine',
			content: [
				{
					id: 31,
					name: 'Domande sul servizio (come funziona)',
					type: 'Domande sul servizio (come funziona)'
				},
				{
					id: 32,
					name: 'Domande sull’utilizzo dei coupon',
					type: 'Domande sull’utilizzo dei coupon'
				},
				{
					id: 33,
					name: 'Domande sui pagamenti (transazioni rifiutate)',
					type: 'Domande sui pagamenti (transazioni rifiutate)'
				},
				{
					id: 34,
					name: 'Problematiche tecniche',
					type: 'Problematiche tecniche'
				}
			]
		},
		4: {
			name: 'Vorrei lasciare un parere sul servizio / hai suggerimenti',
			content: [
				{
					id: 41,
					name: "Vorrei lasciare un parere sul servizio / hai suggerimenti",
					type: ''
				}
			]
		}
	},
	components: {
		TriangleImage,
		FreshdeskForm,
		'greeting-component': HomeGreeting
	},

	props: {
		user: {
			type: Object,
			default () {
				return null
			}
		}
	},

	data () {
		return {
			openedCategoryId: null,
			complited: false
		}
	},

	watch: {
		openedCategoryId () {
			this.formParamsHandle()
		}
	},

	methods: {
		formParamsHandle () {
			if (this.openedCategoryId) {
				this.sectionName = this.$options.faq[this.openedCategoryId].name
				this.subjects = this.$options.faq[this.openedCategoryId].content
			}
		},

		toggle (categoryId) {
			if (categoryId === this.openedCategoryId) this.openedCategoryId = null
			else {
				this.openedCategoryId = categoryId
				this.$nextTick(() => {
					scrollToElementId(categoryId)
				})
			}
		},

		success () {
			this.$router.push({ name: 'freshdesk' })
			scrollToElementId()
			this.complited = true
		},

		goToFaq() {
			this.$router.push({ name: 'faq' })
		}
	}
}

</script>

<style scoped>
h3 {
	text-align: left;
}

.active {
	color: var(--quomi-primary);
}

.label {
	font-size: 18px;
}

.label + .label {
	margin-top: 10px;
}

.container {
	position: relative;
	background-image: url("../assets/img/covers/cover.jpg");
	background-repeat: no-repeat;
	background-position: center 0%;
	background-size: contain;
	padding: 0;
	background-color: white;
}

.container >>> .shadow-box:hover::after {
	box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.16);
}

.container >>> .shadow-box:hover::before {
	box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
}

.content >>> h2 {
	margin-bottom: 10px;
}

.content {
	margin: 0 auto;
	background: white;
	max-width: 800px;
}

.icon {
	margin-right: 10px;
}
.shadow-box {
	padding: 30px;
}

[data-key]:before {
	font-family: 'FontAwesome';
	content: "\f004";
	flex-basis: 25px;
	min-width: 25px;
	height: 25px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 10px;
	color: var(--quomi-darkgrey);
	font-weight: 500;
}

.faq-section {
	margin-top: 20px;
}
.faq-section + .faq-section {
	margin-top: 20px;
}

.faq-category {
	word-wrap : break-word;
	display: flex;
	align-items: center;
	background: #EDEDED;
	margin-top: 20px;
	margin-bottom: -4px;
	border-radius: 4px;
	transition: box-shadow 0.2s;
	cursor: pointer;
	position: relative;
	line-height: 1.2;
	font-size: 15px;
	font-weight: 500;
	padding: 12px;
}

.faq-subcategory {
	margin-top: 20px;
	margin-left: 30px;
}

.rotated::after {
	-webkit-transform: rotate(-90deg);
	-moz-transform: rotate(-90deg);
	-ms-transform: rotate(-90deg);
	-o-transform: rotate(-90deg);
	transform: rotate(-90deg);
}

.faq-trigger::after {
	margin-left: auto;
	content: '\f078';
	font-family: 'FontAwesome';
	-webkit-backface-visibility: hidden;
	backface-visibility: hidden;
	-webkit-transition-property: -webkit-transform;
	-moz-transition-property: -moz-transform;
	transition-property: transform;
	-webkit-transition-duration: 0.2s;
	-moz-transition-duration: 0.2s;
	transition-duration: 0.2s;
}

.faq-content {
	padding: 10px;
	line-height: 1.6;
}

.go-to-faq{
	display: flex;
	flex-direction: column;
	align-items: center;
}

</style>
